import * as i18next from 'i18next';
import type { TOptions } from 'i18next';

import { DEFAULT_LOCALE } from '../locale.constants';

type TLocaleGetter = () => string;

let localeGetter: TLocaleGetter = () => DEFAULT_LOCALE;

export function bindRequestLocaleGetter(getter: TLocaleGetter): void {
  localeGetter = getter;
}

/** @deprecated Use bindRequestLocaleGetter */
export const bindErrorLocaleGetter = bindRequestLocaleGetter;

export function requestT(
  key: string,
  options?: TOptions & { ns?: string | string[] },
): string {
  const ns = options?.ns ?? 'error';
  const translate = i18next.getFixedT(localeGetter(), ns);
  return translate(key, options);
}

export function translateErrorKey(key: string, options?: TOptions): string {
  return requestT(key, { ...options, ns: 'error' });
}
